import React from "react";

// Images \\
import delivery_1 from "../../assets/images/service_001.jpg";
import delivery_2 from "../../assets/images/services_002.jpg";

// Style \\
import "../../assets/styles/card/deliverCard.scss";

const BigChoiceCard = () => {
  return (
    <div>
      <div className="cardFreeCheck2">
        <div className="image">
          <img src={delivery_1} alt="" />
          <img src={delivery_2} alt="" />
        </div>
        <div className="desc">
          <div className="moto">
            <h4>
              You hava a chance to choose <br /> more and more types of
              fourniture
            </h4>
          </div>

          <div className="plusSides">
            <div className="boxService">
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor sit.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor sit.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum.</p>
              </div>
            </div>
          </div>

          <div className="com">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque tortor ornare ornare. Quisque placerat
              scelerisque tortor ornare ornare Convallis felis vitae tortor
              augue. Velit nascetur proin massa in. Consequat faucibus porttitor
              enim et.
            </p>
            <p className="two">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque. Convallis felis vitae tortor augue. Velit
              nascetur proin massa in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BigChoiceCard;
